export const smSize = 640;
export const mdSize = 768;
export const lgSize = 1281;
export const xlSize = 1440;
export const xxlSize = 1512;
export const xxxlSize = 1920;
